import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import GlobalThemeOverrideSx from './GlobalThemeOverrideSx';
import ClientProvider from './client';
export default createDemo(import.meta.url, GlobalThemeOverrideSx, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/theme-components/demos/global-theme-override-sx/GlobalThemeOverrideSx.tsx",
    "fileName": "GlobalThemeOverrideSx.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Chip from '@mui/material/Chip';\nimport Check from '@mui/icons-material/Check';\n\nconst finalTheme = createTheme({\n  components: {\n    MuiChip: {\n      styleOverrides: {\n        root: ({ theme }) =>\n          theme.unstable_sx({\n            // https://mui.com/system/getting-started/the-sx-prop/#spacing\n            px: 1,\n            py: 0.25,\n            // https://mui.com/system/borders/#border-radius\n            borderRadius: 1, // 4px as default.\n          }),\n        label: {\n          padding: 'initial',\n        },\n        icon: ({ theme }) =>\n          theme.unstable_sx({\n            mr: 0.5,\n            ml: '-2px',\n          }),\n      },\n    },\n  },\n});\n\nexport default function GlobalThemeOverrideSx() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={finalTheme}>\n      <Chip\n        color=\"success\"\n        label={\n          <span>\n            <b>Status:</b> Completed\n          </span>\n        }\n        icon={<Check fontSize=\"small\" />}\n      />\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 44,
        "focusedLines": 11,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { ThemeProvider, createTheme } from '@mui/material/styles';\nimport Chip from '@mui/material/Chip';\nimport Check from '@mui/icons-material/Check';\n\nconst finalTheme = createTheme({\n  components: {\n    MuiChip: {\n      styleOverrides: {\n        root: ({ theme }) =>\n          theme.unstable_sx({\n            // https://mui.com/system/getting-started/the-sx-prop/#spacing\n            px: 1,\n            py: 0.25,\n            // https://mui.com/system/borders/#border-radius\n            borderRadius: 1, // 4px as default.\n          }),\n        label: {\n          padding: 'initial',\n        },\n        icon: ({ theme }) =>\n          theme.unstable_sx({\n            mr: 0.5,\n            ml: '-2px',\n          }),\n      },\n    },\n  },\n});\n\nexport default function GlobalThemeOverrideSx() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={finalTheme}>\n      <Chip\n        color=\"success\"\n        label={\n          <span>\n            <b>Status:</b> Completed\n          </span>\n        }\n        icon={<Check fontSize=\"small\" />}\n      />\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "finalTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Chip"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "          <",
              [
                "span",
                "pl-ent",
                "span"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            [
              "            <",
              [
                "span",
                "pl-ent",
                "b"
              ],
              ">Status:</",
              [
                "span",
                "pl-ent",
                "b"
              ],
              "> Completed"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "          </",
              [
                "span",
                "pl-ent",
                "span"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "        ",
              [
                "span",
                "pl-e",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Check"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fontSize"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 44,
    "focusedLines": 11,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Chip",
      "@mui/icons-material/Check"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
